// ======================================================================
// File Name       : enterpriseNotificationActionCreators
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ActionTypes from '../../../constants/actionTypes/enterpriseNotification';

export function enterpriseNotificationList(result) {
  return {
    type: ActionTypes.ENTERPRISE_NOTIFICATION_LIST,
    resultEnterpriseNotificationList: result,
  };
}

